import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdService} from '@services/ad.service';
import {AlertService} from '@services/alert.service';
import {PublisherLead} from '@models/favorite';

// Commentaire libre du publieur sur un lead (PUT app/leads/{id} {comment})
@Component({
    selector: 'app-lead-comment',
    templateUrl: './lead-comment.component.html',
    styleUrls: ['./lead-comment.component.scss']
})
export class LeadCommentComponent {

    lead: PublisherLead;
    comment = '';
    loading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private adService: AdService,
        private alertService: AlertService,
        public dialogRef: MatDialogRef<LeadCommentComponent>) {
        this.lead = data.lead;
        this.comment = this.lead.comment || '';
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.adService.updateLead(this.lead.id, {comment: this.comment}).subscribe(updated => {
            this.loading = false;
            this.dialogRef.close(updated && updated.comment !== undefined ? updated.comment : this.comment);
        }, error => {
            this.loading = false;
            this.alertService.error(typeof error === 'string' ? error : 'L\'enregistrement du commentaire a échoué.');
        });
    }
}
